import React, { useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BrandForm from "./brand-form"
import {
  CardText,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { PageTabs, PageTitle } from "constants/ui"
import { getTabNames, getTabPermissions } from "helpers/tab_helper"
import PermissionTabs from "components/Common/PermissionTabs"
import { useSelector } from "react-redux"

const BrandDetail = props => {
  document.title = PageTitle.BRAND_DETAIL

  const [activeTab, setactiveTab] = useState("1")

  const { userMenu } = useSelector(state => ({
    userMenu: state.userMenu?.userMenu || []
  }))

  const tabNames = getTabNames("BRAND_DETAIL", userMenu)
  const tabPermissionsArray = getTabPermissions("BRAND_DETAIL", "detail", userMenu)

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  const renderTabContent = (tabName, tabIndex) => {
    switch (tabName.toLowerCase()) {
      case 'brand':
        return <BrandForm page="update" {...props} />

      default:
        return (
          <div className="text-center p-5">
            <p className="text-muted">{tabName}</p>
            <h5>Coming soon</h5>
          </div>
        )
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            titleLink="/brands"
            title={PageTitle.BRAND_LIST}
            breadcrumbItem={PageTitle.BRAND_DETAIL}
          />
          <Row>
            <Col md="6">
              <PermissionTabs
                tabs={tabNames}
                activeTab={activeTab}
                onTabChange={toggle}
                tabPermissions={tabPermissionsArray}
                history={props.history}
              />

              <TabContent activeTab={activeTab} className="p-3 text-muted">
                {tabNames.map((tabName, index) => {
                  const tabIndex = index + 1
                  const tabId = String(tabIndex)

                  return (
                    <TabPane key={tabId} tabId={tabId}>
                      {renderTabContent(tabName, tabIndex)}
                    </TabPane>
                  )
                })}
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BrandDetail
